import { requestBuilder } from '../../http/RequestBuilder';

export interface UserEmploymentDetails {
    employmentType?: string;
    occupationIndustry?: string;
}

interface UseGetUserEmploymentDetailsParams {
    userId: string;
}

const useGetUserEmploymentDetailsQuery = requestBuilder.query<
    UserEmploymentDetails | null,
    UseGetUserEmploymentDetailsParams
>({
    endpoint: ({ userId }) => `/api/user/${userId}/employment-details`,
    queryKey: ({ userId }) => [`user`, userId, `employment-details`],
});

export const useGetUserEmploymentDetails = (
    params: UseGetUserEmploymentDetailsParams,
) => {
    return useGetUserEmploymentDetailsQuery(params);
};
